/**
 * SessionStorage wrapper utilities
 * Provides type-safe access to sessionStorage with error handling
 */

const REDIRECT_URL_KEY = 'ep-after-login-redirect-url';
const JUST_LOGGED_OUT_KEY = 'ep-just-logged-out';

export const sessionStorageUtils = {
  /**
   * Set after login redirect URL (used for post-login redirect)
   */
  setAfterLoginRedirectUrl: (url: string): void => {
    try {
      if (typeof window !== 'undefined') {
        window.sessionStorage.setItem(REDIRECT_URL_KEY, url);
      }
    } catch (error) {
      console.error('Failed to set redirect URL:', error);
    }
  },

  /**
   * Get after login redirect URL
   */
  getAfterLoginRedirectUrl: (): string | null => {
    try {
      if (typeof window !== 'undefined') {
        return window.sessionStorage.getItem(REDIRECT_URL_KEY);
      }
      return null;
    } catch (error) {
      console.error('Failed to get redirect URL:', error);
      return null;
    }
  },

  /**
   * Clear after login redirect URL
   */
  clearAfterLoginRedirectUrl: (): void => {
    try {
      if (typeof window !== 'undefined') {
        window.sessionStorage.removeItem(REDIRECT_URL_KEY);
      }
    } catch (error) {
      console.error('Failed to clear redirect URL:', error);
    }
  },

  /**
   * Set flag indicating user just logged out
   */
  setJustLoggedOut: (): void => {
    try {
      if (typeof window !== 'undefined') {
        window.sessionStorage.setItem(JUST_LOGGED_OUT_KEY, 'true');
      }
    } catch (error) {
      console.error('Failed to set just logged out flag:', error);
    }
  },

  /**
   * Check if user just logged out
   */
  hasJustLoggedOut: (): boolean => {
    try {
      if (typeof window !== 'undefined') {
        return window.sessionStorage.getItem(JUST_LOGGED_OUT_KEY) === 'true';
      }
      return false;
    } catch (error) {
      console.error('Failed to check just logged out flag:', error);
      return false;
    }
  },

  /**
   * Clear just logged out flag
   */
  clearJustLoggedOut: (): void => {
    try {
      if (typeof window !== 'undefined') {
        window.sessionStorage.removeItem(JUST_LOGGED_OUT_KEY);
      }
    } catch (error) {
      console.error('Failed to clear just logged out flag:', error);
    }
  },
};
